var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99906 3.2335L3.3324 4.16683L4.26573 2.50016L3.3324 0.833496L4.99906 1.76683L6.66573 0.833496L5.7324 2.50016L6.66573 4.16683L4.99906 3.2335ZM12.9991 9.76683L14.6657 8.8335L13.7324 10.5002L14.6657 12.1668L12.9991 11.2335L11.3324 12.1668L12.2657 10.5002L11.3324 8.8335L12.9991 9.76683ZM14.6657 0.833496L13.7324 2.50016L14.6657 4.16683L12.9991 3.2335L11.3324 4.16683L12.2657 2.50016L11.3324 0.833496L12.9991 1.76683L14.6657 0.833496ZM8.8924 8.02016L10.5191 6.3935L9.10573 4.98016L7.47906 6.60683L8.8924 8.02016ZM9.57906 4.36016L11.1391 5.92016C11.3991 6.16683 11.3991 6.60016 11.1391 6.86016L3.35906 14.6402C3.09906 14.9002 2.66573 14.9002 2.41906 14.6402L0.859062 13.0802C0.599063 12.8335 0.599063 12.4002 0.859062 12.1402L8.63906 4.36016C8.89906 4.10016 9.3324 4.10016 9.57906 4.36016Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.a3a386930e09582d8ce84abbb4182af4.svg";
export { ForwardRef as ReactComponent };